import React, { useLayoutEffect, useRef } from "react";
import { useNavigate} from "react-router-dom";
import Btn_rect from "./Btn_rect.js";
import NewsLetter from "./Newsletter";

import "./Footer.css";

import fulllogo  from "../assets/ArgusBlackLogo.png";

import gsap from "gsap";

import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);






const Footer = () => {
  const wrapperRef = useRef(null);
  const blueRef = useRef(null);
  const navigate = useNavigate();

  // useLayoutEffect(() => {
  //   // scope GSAP selectors to this component
  //   const ctx = gsap.context(() => {
  //   ScrollTrigger.create({
  //     trigger: wrapperRef.current,
  //     start: "top top",
  //     end: () => `+=${blueRef.current.offsetHeight * 0.001}`,
  //     pin: blueRef.current,
  //     pinSpacing: true, // IMPORTANT
  //     anticipatePin: 1,
  //     invalidateOnRefresh: true
  //   });
  // }, wrapperRef);

  // ScrollTrigger.refresh();

  //   return () => ctx.revert(); // kill ScrollTriggers when component unmounts
  // }, []);

  return (
    <section ref={wrapperRef} className="cta-wrapper">
      {/* BLUE SECTION (gets pinned) */}
      <div ref={blueRef} className="cta-blue">
        <div className="footer_wrapper_blue">
            <div className="cta-left">
              <p className="cta-overline">Ready to get</p>
              <h2 className="cta-blue-head">started?</h2>
            </div>
            <div className="cta-right">
              <p className="cta-subtext">
                If solutions you seek, let’s speak!
              </p>
              <Btn_rect label="Contact Us" onClick={()=>{navigate("/contact")}}/>
            </div>
        </div>
      </div>

      {/* BLACK SECTION (scrolls up and overlaps) */}
      <div className="cta-black">
        <div className="footer_logo_wrapper">
          <img className="full_logo" src={fulllogo} />
        </div>
        
        <div className="cta-black-content">

            <div className="cta-newsletter">
                <NewsLetter/>
            </div>

            <div className="cta-links-grid">
                <div className="cta-col">
                <h4>QUICK LINKS</h4>
                <ul>
                    <li onClick={()=>{navigate('/');}} >Home</li>
                    <li onClick={()=>{navigate('/supplychain');}}>Supply Chain Optimizations</li>
                    <li onClick={()=>{navigate('/Predictive');}}>Predictive Maintenance</li>
                    <li onClick={()=>{navigate('/Security');}}>Security & Surveillance</li>
                    <li onClick={()=>{navigate('/Smart');}}>Smart Inventory Management</li>
                    <li onClick={()=>{navigate('/Enhanced');}}>Enhanced Customer Experience</li>
                </ul>
                </div>

                <div className="cta-col">
                <h4>SOCIAL</h4>
                <ul>
                    <li>
                       <a href="https://www.linkedin.com/company/ekakinn/" 
                          target="_blank" 
                          rel="noopener noreferrer"
                          
                        >Linkedin</a>
                      </li>
                    <li>
                      <a href="https://www.facebook.com/EkakInn/" 
                          target="_blank" 
                          rel="noopener noreferrer"
                      >Facebook</a>
                    </li>

                    <li>
                      <a href="https://www.instagram.com/ekak1nn/" 
                          target="_blank" 
                          rel="noopener noreferrer"
                      >Instagram</a>
                    </li>
                      <li>
                      <a href="http://www.youtube.com/@Ekak1nn" 
                          target="_blank" 
                          rel="noopener noreferrer"
                      >YouTube</a></li>
                      <li>
                      <a href="https://x.com/Ekak_Innovation" 
                          target="_blank" 
                          rel="noopener noreferrer"
                      >X</a></li>
                </ul>
                </div>

                <div className="cta-col">
                <h4>CONTACT</h4>
                <ul>
                    <li>
                      <a href="mailto:contact@ekak.in" 
                          target="_blank" 
                          rel="noopener noreferrer"
                      >contact@ekak.in</a>
                    </li>
                    <li>116/216-B Swaroop Nagar,<br/>Kanpur, UP 208002</li>
                </ul>
                </div>

                <div className="cta-col">
                <h4>POLICY</h4>
                <ul>
                    <li onClick={()=>{navigate('/Terms');}}>Terms & Conditions</li>
                    <li onClick={()=>{navigate('/Privacy');}}>Privacy Policy</li>
                    <li onClick={()=>{navigate('/Accessibility');}}>Accessibility Statement</li>
                </ul>
                </div>
            </div>
            </div>

            {/* COPYRIGHT */}
            <div className="cta-black-bottom">
            © All rights reserved by Ekak Innovations Pvt. Ltd. 2026.
            </div>
      </div>
    </section>
  );
};

export default Footer;
